<template>
    <div>
        <section class="xlrclh">
            <img class="top-img" src="./../assets/imgs/xllh/rpjh.png" alt="" />
            <div class="technological-process">
                <div class="zcjj">
                    <img class="top" style="height: 1.12rem" src="./../assets/imgs/xllh/rcgyysq_zcjj.png" alt="" />
                    <div class="content">
                        <div class="des">
                            <div style="
                                            font-size: 0.34rem;
                                            font-weight: bold;
                                            margin-bottom: 0.22rem;
                                        ">
                            </div>
                            聚焦创新驱动引领高质量发展，紧扣成渝地区双城经济圈、成都都市圈、践行新发展理念的公园城市示范区建设等重大部署，以及“三个做优做强”“四大结构优化调整”、产业建圈强链、智慧蓉城建设等中心工作，引进一批契合城市发展的急需紧缺人才和团队。
                        </div>
                    </div>
                </div>
                <div class="contact">
                    <img class="top" src="./../assets/imgs//xllh/rcgysq_sqdx.png" alt="" />
                    <div class="content" style="font-weight: 500; font-size: 0.26rem;">
                        以“高精尖缺”为导向，聚焦主导产业和“卡脖子”领域，重点支持引进一批科技创新主力军，统筹引进哲学社科、现代金融、社会治理、乡村振兴等其他领域领军人才。
                    </div>
                </div>
                <div class="contact">
                    <img class="top" src="./../assets/imgs//xllh/rpjh-zczz-t.png" alt="" />
                    <div class="content" style="font-weight: 500; font-size: 0.26rem;">
                        给予个人最高300万、团队最高1000万元资助。发放“蓉城人才绿卡（市级卡)”，给予职务职称、薪酬待遇、创新创业、出入境与居留、人才安居、子女入园入学、医疗保险、培训休假等方面支持保障。
                    </div>
                </div>
                <div class="contact">
                    <img class="top" src="./../assets/imgs//xllh/rpjh-sqlc-t.png" alt="" />
                    <div class="content" style=" font-size: 0.3rem;">
                        以当年申报通知为准。
                    </div>
                </div>
                <div class="contact">
                    <img class="top" src="./../assets/imgs/xllh/rclh-more.png" alt="" />
                    <div class="content">
                        按照每年度通知时间确定。
                    </div>
                </div>
                <div class="contact">
                    <img class="top" src="./../assets/imgs/xllh/rclu-zrdw.png" alt="" />
                    <div class="content">
                        <div class="number">
                            <span class="label">政策咨询电话：</span>
                            <div>
                                <a href="tel:028-61886095">028-61886095</a>
                            </div>
                        </div>
                        <div class="unit">
                            <span class="label">责任单位：</span>
                            成都市委组织部
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <call phone="028-61886095"></call>
    </div>
</template>

<script>
import call from "../components/call.vue";
export default {
    data() {
        return {};
    },

    components: {
        call,
    },


    mounted() { },

    methods: {},
};
</script>
<style lang="scss" scoped>
@import "@/assets/public.scss";

.xlrclh {
    background-color: $base-back;
    min-height: 100vh;

    // padding-bottom: 3.7rem;
    .top-img {
        width: 7.47rem;
        height: 5.6rem;
    }

    .technological-process {
        transform: translateY(-1.9rem);

        .zcjj {
            .top {
                width: 6.68rem;
                height: 2.12rem;
            }

            .content {
                width: 6.68rem;
                background: #ffffff;
                margin: -0.45rem auto 0;
                padding: 0.1rem 0.33rem 0.64rem 0.36rem;
                box-sizing: border-box;
                border-radius: 0rem 0rem 0.26rem 0.26rem;
                line-height: 0.44rem;


                .title {
                    font-size: 0.34rem;
                    font-weight: bold;
                    color: #333333;
                    text-align: left;
                    line-height: 0.5rem;
                }

                .des {
                    font-size: 0.26rem;
                    font-weight: 500;
                    color: #4e4e4e;
                    line-height: 0.44rem;
                    text-align: left;
                    margin-top: 0.16rem;
                }
            }
        }

        .rhtj {
            position: relative;

            .top {
                width: 7.03rem;
                height: 1.37rem;
                margin-left: -0.18rem;
            }

            .content {
                width: 6.85rem;
                background: #e8eeff;
                margin: -0.45rem auto 0;
                padding: 0 0.33rem 0.64rem 0.36rem;
                box-sizing: border-box;
                border-radius: 0rem 0rem 0.26rem 0.26rem;

                .title {
                    font-size: 0.36rem;
                    font-weight: bold;
                    color: #333333;
                    text-align: left;
                    line-height: 0.5rem;
                }

                .des {
                    font-size: 0.26rem;
                    color: #4e4e4e;
                    background: #ffffff;
                    border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
                    padding: 0.3rem 0.23rem 0.3rem;
                    text-align: left;
                    line-height: 0.44rem;
                    position: relative;

                    .cdcslt {
                        width: 6.03rem;
                        height: 1.94rem;
                    }

                    .describe {
                        background: linear-gradient(180deg,
                                #ffffff 0%,
                                rgba(255, 255, 255, 0) 100%);
                        border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
                        opacity: 1;
                        padding: 0.33rem 0.33rem 0 0.15rem;

                        .num {
                            min-width: 0.39rem;
                            height: 0.39rem;
                            background: #739bfe;
                            color: #ffffff;
                            display: inline-flex;
                            border-radius: 50%;
                            justify-content: center;
                            align-items: center;
                            margin-right: 0.14rem;
                        }
                    }
                }
            }
        }

        .gmlc {
            position: relative;
            margin-top: 0.22rem;

            .top {
                width: 7.03rem;
                height: 1.37rem;
                margin-left: -0.18rem;
            }

            .content {
                width: 6.85rem;
                background: #e8eeff;
                margin: -0.45rem auto 0;
                padding: 0.33rem;
                box-sizing: border-box;
                border-radius: 0rem 0rem 0.26rem 0.26rem;

                .title {
                    font-size: 0.3rem;
                    font-weight: bold;
                    color: #333333;
                    text-align: left;
                    line-height: 0.5rem;
                }

                .des {
                    color: #4e4e4e;
                    text-align: left;
                    background: #ffffff;
                    border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
                    padding: 0.3rem 0.23rem;
                    font-size: 0.26rem;
                    color: #4e4e4e;

                    position: relative;
                    line-height: 0.44rem;
                    margin-top: 0.8rem;

                    .title {
                        position: absolute;
                        top: -0.5rem;
                        left: 50%;
                        transform: translateX(-50%);
                        width: 4.5rem;
                        height: 0.67rem;
                        line-height: 0.67rem;
                        display: flex;
                        justify-content: center;
                        align-content: center;
                        font-size: 0.32rem;
                        font-weight: bold;
                        color: #ffffff;
                        border-radius: 1rem;
                        background-color: #739bfe;
                    }

                    .line-item {
                        font-size: 0.26rem;
                        position: relative;
                        z-index: 3;

                        .line {
                            position: absolute;
                            width: 0.02rem;
                            height: 100%;
                            border-left: 0.02rem dashed #739bfe;
                            left: 0.2rem;
                            z-index: 0;
                            //   background-color: #739bfe;
                        }

                        .line-title {
                            font-size: 0.3rem;
                            font-weight: bold;
                            color: #3d5aa3;
                            line-height: 0.46rem;
                        }

                        .line-top {
                            display: flex;

                            .line-num {
                                min-width: 0.39rem;
                                height: 0.39rem;
                                line-height: 0.39rem;
                                background: #739bfe;
                                color: #ffffff;
                                display: inline-flex;
                                border-radius: 50%;
                                justify-content: center;
                                align-items: center;
                                align-content: center;
                                margin-right: 0.14rem;
                                position: relative;
                                z-index: 3;
                            }
                        }

                        .line-content {
                            //   border-left: 0.02rem dashed #739bfe;
                            padding-bottom: 0.32rem;
                            margin-left: 0.2rem;
                            padding-left: 0.32rem;
                            padding-top: 0.15rem;
                            word-break: break-all;
                            line-height: 0.44rem;
                        }
                    }

                    .des-item {
                        font-size: 0.26rem;
                        color: #4e4e4e;
                        padding-left: 0.33rem;
                        padding-top: 0.22rem;
                        margin-left: 0.2rem;
                        border-left: 0.02rem dashed #739bfe;
                        padding-bottom: 0.55rem;

                        .cdrcwewm {
                            width: 5.51rem;
                            height: 1.43rem;
                            margin-top: 0.16rem;
                        }
                    }

                    .describe-item {
                        font-size: 0.26rem;
                        color: #4e4e4e;
                        padding-left: 0.33rem;
                        padding-top: 0.22rem;
                        margin-left: 0.2rem;
                        word-break: break-all;
                    }
                }
            }
        }

        .gmlc2 {
            position: relative;
            margin-top: 0.22rem;

            .top {
                width: 7.03rem;
                height: 1.37rem;
                margin-left: -0.18rem;
            }

            .content {
                width: 6.85rem;
                background: #fff;
                margin: -0.45rem auto 0;
                padding: 0.33rem;
                box-sizing: border-box;
                font-size: 0.26rem;
                color: #4e4e4e;
                line-height: 0.44rem;

                text-align: left;
                border-radius: 0rem 0rem 0.26rem 0.26rem;
            }
        }
    }
}
</style>
